import { getUrl } from '../config';

/**
 * 带上访问地址上的所有参数
 */
const generateURL = (originParams, url) => {
  // console.log('generateURL', url, params)
  let params
  if (originParams.noParam) {
    return getUrl(url)
  }
  if (originParams.pdt) {
    params = originParams
  } else {
    params = Object.assign({}, originParams, {
      Pdt: 'jpkWeb',
    })
  }
  let result = ''
  const keys = Object.keys(params)
  keys.forEach((key) => {
    if (url.indexOf(key) === -1) {
      result = `${result}${key}=${params[key]}&`
    }
  })
  result = result.slice(0, -1)

  if (!result) return url
  if (url.indexOf('?') === -1) {
    const str = `${url}?${result}`;
    // 云课堂url特殊处理
    return getUrl(str);
  }

  const str = `${url}&${result}`;
  // 云课堂url特殊处理
  return getUrl(str);
}


export default function (params) {
  return (url, extraParams) => generateURL(extraParams ?
    Object.assign({}, params, extraParams)
    : params, url)
}



// WEBPACK FOOTER //
// ./src/core/urlGeneratorHelper.js